module.exports = __webpack_public_path__ + "img/24.823ad39f.jpg";